import { render } from "./PettyCashView.vue?vue&type=template&id=1c78630b"
import script from "./PettyCashView.vue?vue&type=script&lang=js"
export * from "./PettyCashView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__